import type { ProductChoice } from '../../utils/Data/customizeConnector';

export const getAdditionalsAndTotal = (choices: ProductChoice[]) => {
  const additionals: ProductChoice[] = [];
  let total: number = 0;
  choices.forEach((choice) => {
    if (choice.additionals.length && choice.additionals?.length > 0) {
      const enhancedAdditionals = choice.additionals
        .map((a: ProductChoice) => ({
          ...a,
          additionalItemCost: choice.additionalItemCost,
        }));
      additionals.push(...enhancedAdditionals);
      total += (choice.additionalQuantity * choice.additionalItemCost);
    }
  });

  return { additionals, total };
};

export const getPriceForDescription = (number: number) => (number).toFixed(2);
